<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="goldCode">
        <span slot="label">
          <a-tooltip>金属code<template slot="title">金属code</template></a-tooltip>
        </span>
        <a-input v-model="form.goldCode" :maxLength="32" placeholder="请输入金属code'"/>
      </a-form-model-item>
      <a-form-model-item prop="goldName">
        <span slot="label">
          <a-tooltip>金属名称<template slot="title">金属名称</template></a-tooltip>
        </span>
        <a-input v-model="form.goldName" :maxLength="32" placeholder="请输入金属名称'"/>
      </a-form-model-item>
      <a-form-model-item prop="unit">
        <span slot="label">
          <a-tooltip>单位(g)<template slot="title">单位(g)</template></a-tooltip>
        </span>
        <a-input v-model="form.unit" :maxLength="8" placeholder="请输入单位'"/>
      </a-form-model-item>
      <a-form-model-item prop="unitRatio">
        <span slot="label">
          <a-tooltip>单位换算<template slot="title">单位换算</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.unitRatio" :min="1" placeholder="请输入单位换算'"/>
      </a-form-model-item>
      <a-form-model-item prop="todayPrice">
        <span slot="label">
          <a-tooltip>今日价格<template slot="title">今日价格</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.todayPrice"  :min="0" :max="99999999" :step="0.01" placeholder="请输入今日价格'"/>
      </a-form-model-item>
      <a-form-model-item prop="yesterdayPrice">
        <span slot="label">
          <a-tooltip>昨日价格<template slot="title">昨日价格</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.yesterdayPrice"  :min="0" :max="99999999" :step="0.01" placeholder="请输入昨日价格'"/>
      </a-form-model-item>
      <a-form-model-item prop="recyclingPrice">
        <span slot="label">
          <a-tooltip>回收价格<template slot="title">回收价格</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.recyclingPrice"  :min="0" :max="99999999" :step="0.01" placeholder="请输入回收价格'"/>
      </a-form-model-item>
      <a-form-model-item prop="todayServicePrice">
        <span slot="label">
          <a-tooltip>今日价格服务费<template slot="title">【今日价格】的构成是行情加上服务费</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.todayServicePrice"  :min="0" :max="99999999" :step="0.01" placeholder="请输入服务费'"/>
      </a-form-model-item>
      <a-form-model-item prop="recyclingServicePrice">
        <span slot="label">
          <a-tooltip>回收价格服务费<template slot="title">【回收价格】是当前行情价减去服务费</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.recyclingServicePrice"  :min="0" :max="99999999" :step="0.01" placeholder="请输入服务费'"/>
      </a-form-model-item>
      <a-form-model-item prop="isHomeVisible">
        <span slot="label">
          <a-tooltip>是否首页展示<template slot="title">是否首页展示</template></a-tooltip>
        </span>
        <a-select placeholder="请选择类型" style="width: 100%" v-model="form.isHomeVisible" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="sort">
        <span slot="label">
          <a-tooltip>排序<template slot="title">排序</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.sort" :min="0" placeholder="请输入排序'"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getGoldPrice, addGoldPrice, updateGoldPrice} from '@/api/gold/goldPrice'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        goldCode: null,
        goldName: null,
        sort: 0,
        unitRatio: 1,
        todayPrice: null,
        yesterdayPrice: null,
        recyclingPrice: null,
        todayServicePrice: 0,
        recyclingServicePrice:0,
        isHomeVisible: undefined,
        unit: null,
        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goldCode: [{required: true, message: '金属code' + '不能为空', trigger: 'blur'}],
        goldName: [{required: true, message: '金属名称' + '不能为空', trigger: 'blur'}],
        unit: [{required: true, message: '单位' + '不能为空', trigger: 'blur'}],
        todayPrice: [{required: true, message: '今日价格' + '不能为空', trigger: 'blur'}],
        yesterdayPrice: [{required: true, message: '昨日价格' + '不能为空', trigger: 'blur'}],
        recyclingPrice: [{required: true, message: '回收价格' + '不能为空', trigger: 'blur'}],
        todayServicePrice: [{required: true, message: '服务费' + '不能为空', trigger: 'blur'}],
        isHomeVisible: [{required: true, message: '是否首页展示' + '不能为空', trigger: 'blur'}],
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        goldCode: null,
        goldName: null,
        todayPrice: null,
        yesterdayPrice: null,
        recyclingPrice: null,
        todayServicePrice: 0,
        recyclingServicePrice:0,
        isHomeVisible: undefined,
        unit: null,
        unitRatio: 1,
        sort: 0,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoldPrice({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = '修改成功'
            updateGoldPrice(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = '修改成功'
            addGoldPrice(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
